<template>
  <div class="bottom-bar">
    <payment-methods v-show="screenLgPlus"></payment-methods>
    <p class="bottom-bar__paragraph">
      Feito com <span class="bottom-bar__heart"> ❥ </span> pela
      <a
        class="bottom-bar__link"
        href="http://quero.education"
        target="_blank"
        rel="noopener noreferrer"
      >
        Quero Educação
      </a>
    </p>
    <p class="bottom-bar__paragraph bottom-bar__paragraph--company-info">
      Quero Educação © 2011 - {{ currentYear }} <br class="d-md-none d-lg-block">
      CNPJ: 10.542.212/0001-54
    </p>
  </div>
</template>

<style lang="sass" scoped>

  @import '~/assets/stylesheets/utils/module.sass'

  .bottom-bar
    color: $footer-color
    font-size: 12px
    padding: 7px 0 18px 0
    text-align: center

    @media (min-width: $screen-md-min)
      display: flex
      justify-content: space-between

    @media (min-width: $screen-lg-min)
      align-items: center
      padding-top: 18px

  .bottom-bar__heart
    font-size: 18px
    vertical-align: bottom
    transform: scaleY(1.1) rotate(90deg) translateX(3px)
    display: inline-block
    margin-right: $space-xxs

  .bottom-bar__link
    color: $footer-color
    text-decoration: underline

  .bottom-bar__paragraph
    line-height: 1.3
    margin: 0

  .bottom-bar__paragraph--company-info
    @media (min-width: $screen-md-min)
      margin-top: 9px
      order: -1

    @media (min-width: $screen-lg-min)
      text-align: left

</style>

<script>
  import PaymentMethods from '~/components/footer/payment-methods';

  export default {
    data() {
      return {}
    },
    components: {
      PaymentMethods,
    },
    computed: {
      currentYear() {
        return (new Date()).getFullYear();
      },
      screenLgPlus() {
        return (this.$mq === 'lg' || this.$mq === 'xl');
      }
    }
  }
</script>
